export default {
  fr: {
    title: 'Ces projets pourraient vous intéresser',
  },
  en: {
    title: 'These projects might interest you',
  },
  'pt-br': {
    title: 'Esses projetos podem te interessar',
  },
  es: {
    title: 'Estos proyectos podrían interesarte',
  },
  de: {
    title: 'Diese Projekte könnten Sie interessieren',
  },
} as const
